import { Route } from '@angular/router';

import { MixedContentPageResolverComponent } from '../ui/mixed-content/mixed-content-page-resolver.component';

export type PageResolverRouteChildren = {
  path: string;
  pathMatch?: 'prefix' | 'full';
};

export const mixedContentPageResolverRoutes = (routeChildrens: PageResolverRouteChildren[]): Route[] => [
  {
    path: '',
    children: routeChildrens.map((children) => {
      return {
        path: children.path,
        component: MixedContentPageResolverComponent,
        pathMatch: children.pathMatch ?? 'prefix',
      };
    }),
  },
];
